/* eslint-disable max-lines-per-function */
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { CalendarSelectProps } from '@/domain/termine/features/CreateTermin/shared/types/types';
import { useDrawerSelection } from '../hooks/useDrawerSelection';

export function CalendarSelectDrawer({
  kalender,
  value,
  onChange,
}: CalendarSelectProps) {
  const { t } = useTranslation();
  const { localSelection, handleOpenChange, handleSelect, handleConfirm } =
    useDrawerSelection<string>(value, onChange);

  const selectedKalender = kalender.find((k) => k.id === localSelection);
  const displayText = selectedKalender?.name;

  return (
    <Drawer onOpenChange={handleOpenChange}>
      <DrawerTrigger asChild>
        <Button
          variant="outline-secondary"
          className="flex items-center justify-between w-full">
          <span className="text-sm">{displayText}</span>
          <FontAwesomeIcon icon={faChevronDown} className="text-neutrals-400" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col">
        <DrawerHeader className="px-3 pb-0">
          <DrawerTitle className="text-sm text-center text-neutrals-900 font-semibold pt-2">
            {t('domain.termine.terminCalendar')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.terminCalendar')}
          </DrawerDescription>
        </DrawerHeader>
        <ScrollArea className="flex-1 px-4" data-vaul-no-drag>
          <div className="space-y-0">
            {kalender.map((kalenderItem, idx) => {
              const isSelected = localSelection === kalenderItem.id;
              return (
                <div key={kalenderItem.id}>
                  <Button
                    variant="ghost"
                    aria-selected={isSelected}
                    onClick={() => handleSelect(kalenderItem.id)}
                    className="w-full justify-between">
                    <span className="text-sm font-medium">
                      {kalenderItem.name}
                    </span>
                    {isSelected && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="text-primary-blue-600"
                      />
                    )}
                  </Button>
                  {idx < kalender.length - 1 && (
                    <div className="border-b border-neutrals-300" />
                  )}
                </div>
              );
            })}
          </div>
        </ScrollArea>
        <div className="p-4 shrink-0">
          <DrawerClose asChild>
            <Button className="w-full" size="lg" onClick={handleConfirm}>
              {t('domain.termine.form.fertig')}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
